<template>
  <div>
    <div class="login-page">
      <top></top>
      <div class="container">
        <el-page-header @back="goBack"> </el-page-header>
        <div class="row">
          <div class="rowLeft">
            <ul>
              <li>
                <img
                  src="	https://img.eqlee.com/upload/woyou/20161104/636138656862266590.jpg"
                  alt=""
                  @click="
                    $router.push({ path: '/successDetail', query: { flag: 1 } })
                  "
                />
                <div class="rowLeft-right">
                  <h4
                    @click="
                      $router.push({
                        path: '/successDetail',
                        query: { flag: 1 },
                      })
                    "
                  >
                    第18届中国国际花卉园艺展
                  </h4>
                  <div class="summary">
                    中国国际花卉园艺展览会由中国花卉协会主办，每年在北京、上海两地轮流举办。
                  </div>
                </div>
              </li>
              <li>
                <img
                  src="	https://img.eqlee.com/upload/woyou/20170117/636202489160045699.jpg"
                  alt=""
                  @click="
                    $router.push({ path: '/successDetail', query: { flag: 1 } })
                  "
                />
                <div class="rowLeft-right">
                  <h4
                    @click="
                      $router.push({
                        path: '/successDetail',
                        query: { flag: 1 },
                      })
                    "
                  >
                    全球视野，创新长青 ——中信•泰达创新论坛
                  </h4>
                  <div class="summary">
                    在万物互联和智能革命的今天，同质化与异质化并驾齐驱，碎片化和深度学习同样并行不悖，先行者既需要终身学习，更需要深度思考。知识服务商得到的创始人罗振宇在2016年跨年演讲中给当下创业者给出了全新定义：只要他试图不断地提高自己的认知，达成更新式的协作，做一件前所未有的事。所有这样的人，不管他是一个打工者，还是一个自由职业者，也不管他是为了公司在打拼，还是为了他个人在奋斗，这样的人我们都称之为叫创业者。
                  </div>
                </div>
              </li>
              <li>
                <img
                  src="	https://img.eqlee.com/upload/woyou/20170117/636202488981043484.jpg"
                  alt=""
                  @click="
                    $router.push({ path: '/successDetail', query: { flag: 1 } })
                  "
                />
                <div class="rowLeft-right">
                  <h4
                    @click="
                      $router.push({
                        path: '/successDetail',
                        query: { flag: 1 },
                      })
                    "
                  >
                    2017（第二届）中国CEO新年峰会
                  </h4>
                  <div class="summary">2017（第二届）中国CEO新年峰会</div>
                </div>
              </li>
            </ul>
          </div>
          <div class="rowRight">
            <div class="to-slide-panel to-panel-hot-news">
              <div class="to-slide-header">
                <span>热门案例</span>
              </div>
              <div class="to-slide-body" id="hotarticllist">
                <ul>
                  <li>
                    <span class="to-index to-index-1">1</span
                    ><a title="" @click="$router.push('/successDetail')"
                      >第18届中国国际花卉园艺展</a
                    >
                  </li>
                  <li>
                    <span class="to-index to-index-2">2</span
                    ><a title="" href="/Home/SuccessDetail/9"
                      >全球视野，创新长青 ——中信•泰达创新论坛</a
                    >
                  </li>
                  <li>
                    <span class="to-index to-index-3">3</span
                    ><a title="" href="/Home/SuccessDetail/6"
                      >2017（第二届）中国CEO新年峰会</a
                    >
                  </li>
                  <!-- <li>
                    <span class="to-index to-index-4">4</span
                    ><a title="" href="/Home/SuccessDetail/5"
                      >2016中国数据中心年度论坛</a
                    >
                  </li>
                  <li>
                    <span class="to-index to-index-5">5</span
                    ><a title="" href="/Home/SuccessDetail/4"
                      >易奇会议助力首届世界互联网大会</a
                    >
                  </li> -->
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Foot />
  </div>
</template>

<script>
import Foot from "./_foot";
import top from "./_top_menu";
export default {
  components: {
    Foot,
    top,
  },
  data() {
    return {};
  },
  created() {},

  directives: {
    focus: {
      // 指令的定义
      inserted: function (el) {
        el.focus();
      },
    },
  },

  methods: {
    goBack() {
      this.$router.push("/login");
    },
  },
};
</script>

<style lang="less" scoped>
.login-page {
  width: 100%;
  background-color: #fff;
  // height: 100vh;
  .loginBtn {
    cursor: pointer;
  }
  .container {
    width: 1170px;
    margin: 0 auto;
    padding-top: 60px;
    height: 100vh;
    .row {
      width: 1170px;
      margin: 0 auto;
      display: flex;
      padding-top: 10px;

      justify-content: space-between;
      .rowLeft {
        width: 75%;
        padding-right: 15px;
        padding-left: 15px;
        ul {
          width: 100%;
          margin-top: 15px;
          li {
            padding: 0px 0 20px 0;
            margin-right: 0;
            display: flex;
            justify-content: space-between;
            margin-bottom: 30px;
            border-bottom: 1px solid #e2e2e2;
            img {
              width: 185px;
              height: 115px;
              margin: 0 15px;
              cursor: pointer;
            }
            .rowLeft-right {
              width: 74%;
              // height: 133px;
              display: flex;
              flex-direction: column;
              justify-content: space-between;
              h4 {
                overflow: hidden;
                margin-bottom: 7px;
                height: 25px;
                color: #6e6e6e;
                font-size: 18px;
                margin-top: 10px;
                cursor: pointer;

                font-weight: normal;
              }
              .summary {
                color: rgba(196, 196, 196, 1);
                max-height: 28px;
                overflow: hidden;
                padding-right: 60px;
                font-size: 12px;
                // margin-bottom: 12px;
                // height: 35px;
              }
            }
          }
        }
      }
      .rowRight {
        a {
          color: #6e6e6e;
        }
        .to-slide-header {
          font-size: 18px;
          border-bottom: 1px #e2e2e2 solid;
          span {
            border-bottom: 2px #949494 solid;
            padding-bottom: 5px;
            display: inline-block;
          }
        }
        .to-slide-body {
          padding: 10px 0 10px 0;
          color: #8e8e8e;
          font-size: 12px;
        }
        .to-panel-hot-news li {
          margin-bottom: 17px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .to-index {
          width: 20px;
          height: 20px;
          font-size: 12px;
          display: inline-block;
          background: #b4b4b4;
          margin-right: 10px;
          border-radius: 50%;
          text-align: center;
          color: white;
          line-height: 18px;
        }
        .to-index-1 {
          background-color: #f93b08 !important;
        }
        .to-index-2 {
          background-color: #ffa800 !important;
        }
        .to-index-3 {
          background-color: #0cf !important;
        }
      }
    }
  }
}
.copy-right {
  position: fixed;
  bottom: 0;
  width: 100%;
  background: rgba(0, 0, 0, 0.5);
  color: white;
  text-align: center;
  padding: 10px 0;
}
</style>
